import {svgIconWrapper} from '../svg-icon-wrapper';

import ExportRegular from './export-regular-icon.svg';

function SvgComponent(props: React.SVGProps<SVGSVGElement>) {
    return <ExportRegular {...props} />;
}

SvgComponent.iconName = 'exportRegular';

export const ExportRegularIcon = svgIconWrapper(SvgComponent);
